import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { axiosc } from 'src/app/utils';
import {
  DrawenLayerBulkDeleteType,
  DrawenLayerCreateType,
  DrawenLayerEditType,
  DrawenLayerResultType,
} from 'src/app/helpers/drawenLayer.helper';

export const drawenLayerLookup = (tarafId?: number): AxiosPromise<DrawenLayerResultType[]> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayers}/list/${tarafId || 0}`, {
    blockSpinner: true,
  });
};

export const drawenLayerSingleLookup = (id: number): AxiosPromise<DrawenLayerResultType> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayers}/${id}`, {
    blockSpinner: true,
  });
};

export const drawenLayerCreate = (form: DrawenLayerCreateType): AxiosPromise<DrawenLayerResultType> => {
  return axiosc.post(`${urlsConfig.generics.drawModule.drawenLayers}`, form, { blockErrorHandler: true });
};

export const drawenLayerEdit = (form: DrawenLayerEditType): AxiosPromise<DrawenLayerResultType> => {
  return axiosc.patch(urlsConfig.generics.drawModule.drawenLayers, form, { blockErrorHandler: true });
};

export const drawenLayerDelete = (uuid: string): AxiosPromise<undefined> => {
  return axiosc.delete(`${urlsConfig.generics.drawModule.drawenLayers}/${uuid}`);
};

export const drawenLayerDeleteMany = (form: DrawenLayerBulkDeleteType): AxiosPromise<undefined> => {
  return axiosc.post(`${urlsConfig.generics.drawModule.drawenLayers}/delete`, form);
};

export const drawenLayerCopy = (shapeId: number, ids: number[], names: string, tarafId?: number) => {
  return axiosc.post(`${urlsConfig.generics.drawModule.drawenLayers}/copy/${tarafId || 0}/${shapeId}`, { ids, names });
};
